import { render } from "./UserTypeDialog.vue?vue&type=template&id=4941e74d"
import script from "./UserTypeDialog.vue?vue&type=script&lang=js"
export * from "./UserTypeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__